export class ApplicationError extends Error {
  constructor(message: string, public data: unknown = null) {
    super(message)
    this.name = 'ApplicationError'
  }

  public static fromApiErrorResult(result): ApplicationError {
    return new ApplicationError(result.response?.data?.message || 'Application error', result.response.data)
  }
}
